import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Shield, Clock, ThumbsUp, Facebook, Twitter, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#2C3E50] text-white" data-id="element-134">
      <div className="relative h-64 overflow-hidden" data-id="element-135">
        <img src="https://images.unsplash.com/photo-1556911220-bff31c812dba?w=1600&q=80" alt="Happy family in modern kitchen with appliances - professional repair service" className="w-full h-full object-cover opacity-30" data-id="element-136" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2C3E50] to-transparent" data-id="element-137"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-138">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-139">
          <div data-id="element-140">
            <div className="flex items-center gap-2 mb-4" data-id="element-141">
              <div className="w-10 h-10 bg-[#0D7377] rounded-lg flex items-center justify-center" data-id="element-142">
                <span className="text-white font-bold text-xl" data-id="element-143">C</span>
              </div>
              <span className="text-xl font-bold" data-id="element-144">Caringhand</span>
            </div>
            <p className="text-gray-300 text-sm mb-4" data-id="element-145">
              Professional appliance repair services across the UK. Fast,
              reliable, and transparent.
            </p>
            <div className="flex gap-3" data-id="element-146">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white bg-opacity-10 rounded-full flex items-center justify-center hover:bg-opacity-20 transition-colors" data-id="element-147">
                <Facebook size={20} data-id="element-148" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white bg-opacity-10 rounded-full flex items-center justify-center hover:bg-opacity-20 transition-colors" data-id="element-149">
                <Twitter size={20} data-id="element-150" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white bg-opacity-10 rounded-full flex items-center justify-center hover:bg-opacity-20 transition-colors" data-id="element-151">
                <Instagram size={20} data-id="element-152" />
              </a>
            </div>
          </div>
          <div data-id="element-153">
            <h3 className="font-semibold text-lg mb-4" data-id="element-154">Quick Links</h3>
            <ul className="space-y-2 text-sm" data-id="element-155">
              <li data-id="element-156">
                <Link to="/" className="text-gray-300 hover:text-[#8FB996] transition-colors" data-id="element-157">
                  Home
                </Link>
              </li>
              <li data-id="element-158">
                <Link to="/repair-services" className="text-gray-300 hover:text-[#8FB996] transition-colors" data-id="element-159">
                  Repair Services
                </Link>
              </li>
              <li data-id="element-160">
                <Link to="/about" className="text-gray-300 hover:text-[#8FB996] transition-colors" data-id="element-161">
                  About Us
                </Link>
              </li>
              <li data-id="element-162">
                <Link to="/faqs" className="text-gray-300 hover:text-[#8FB996] transition-colors" data-id="element-163">
                  FAQs
                </Link>
              </li>
              <li data-id="element-164">
                <Link to="/contact" className="text-gray-300 hover:text-[#8FB996] transition-colors" data-id="element-165">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-166">
            <h3 className="font-semibold text-lg mb-4" data-id="element-167">Legal</h3>
            <ul className="space-y-2 text-sm" data-id="element-168">
              <li data-id="element-169">
                <Link to="/terms" className="text-gray-300 hover:text-[#8FB996] transition-colors" data-id="element-170">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-171">
                <Link to="/privacy" className="text-gray-300 hover:text-[#8FB996] transition-colors" data-id="element-172">
                  Privacy & Cookie Policy
                </Link>
              </li>
              <li data-id="element-173">
                <Link to="/refund" className="text-gray-300 hover:text-[#8FB996] transition-colors" data-id="element-174">
                  Refund Policy
                </Link>
              </li>
              <li data-id="element-175">
                <Link to="/cancellation" className="text-gray-300 hover:text-[#8FB996] transition-colors" data-id="element-176">
                  Cancellation Policy
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-177">
            <h3 className="font-semibold text-lg mb-4" data-id="element-178">Contact</h3>
            <ul className="space-y-3 text-sm" data-id="element-179">
              <li className="flex items-start gap-2" data-id="element-180">
                <MapPin size={16} className="mt-1 flex-shrink-0 text-[#8FB996]" data-id="element-181" />
                <span className="text-gray-300" data-id="element-182">
                  157 Ashley Rd, Hale, Altrincham WA15 9SD
                </span>
              </li>
              <li className="flex items-center gap-2" data-id="element-183">
                <Phone size={16} className="flex-shrink-0 text-[#8FB996]" data-id="element-184" />
                <a href="tel:08000554969" className="text-gray-300 hover:text-[#8FB996] transition-colors" data-id="element-185">
                  0800 055 4969
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-186">
                <Mail size={16} className="flex-shrink-0 text-[#8FB996]" data-id="element-187" />
                <a href="mailto:info@caringhand.it.com" className="text-gray-300 hover:text-[#8FB996] transition-colors" data-id="element-188">
                  info@caringhand.it.com
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-189">
                <Clock size={16} className="mt-1 flex-shrink-0 text-[#8FB996]" data-id="element-190" />
                <div className="text-gray-300" data-id="element-191">
                  <p data-id="element-192">Mon-Fri: 9:00-17:00</p>
                  <p data-id="element-193">Sat-Sun: Closed</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-8 pb-6" data-id="element-194">
          <div className="grid md:grid-cols-3 gap-6 mb-6" data-id="element-195">
            <div className="flex items-center gap-3" data-id="element-196">
              <div className="w-12 h-12 bg-white bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-197">
                <Shield className="text-[#8FB996]" size={24} data-id="element-198" />
              </div>
              <div data-id="element-199">
                <p className="font-semibold text-sm" data-id="element-200">Qualified Engineers</p>
                <p className="text-xs text-gray-400" data-id="element-201">
                  Fully trained technicians
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-202">
              <div className="w-12 h-12 bg-white bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-203">
                <Clock className="text-[#8FB996]" size={24} data-id="element-204" />
              </div>
              <div data-id="element-205">
                <p className="font-semibold text-sm" data-id="element-206">Fast Response</p>
                <p className="text-xs text-gray-400" data-id="element-207">Within 48 hours</p>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-208">
              <div className="w-12 h-12 bg-white bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-209">
                <ThumbsUp className="text-[#8FB996]" size={24} data-id="element-210" />
              </div>
              <div data-id="element-211">
                <p className="font-semibold text-sm" data-id="element-212">Clear Pricing</p>
                <p className="text-xs text-gray-400" data-id="element-213">No hidden fees</p>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-6 text-center text-sm text-gray-400" data-id="element-214">
          <p data-id="element-215">
            &copy; {new Date().getFullYear()} Caringhand. All rights reserved. |
            MCC 1731 Electrical Contractors
          </p>
        </div>
      </div>
    </footer>;
}